import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../api/api';
import '../../css/Login.css';

const AdminLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [adminPassword, setAdminPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const savedEmail = localStorage.getItem('adminSavedEmail');
    if (savedEmail) setEmail(savedEmail);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const response = await api.post('/staff-login', {
        email,
        password: adminPassword,
      });

      if (response.data && response.data.success) {
        // Clear other role's tokens
        localStorage.removeItem('authToken');

        // Save admin data
        localStorage.setItem('adminAuthToken', response.data.access_token);
        localStorage.setItem('adminSavedEmail', email);
        localStorage.setItem('adminRole', response.data.user.role);
        localStorage.setItem('adminName', response.data.user.firstname);
        localStorage.setItem('currentRole', 'admin'); // 🔑 Identify role

        navigate('/admin-dashboard');
      } else {
        setError('Invalid admin credentials');
      }
    } catch (err) {
      setError('Login failed. Please try again.');
      console.error(err);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(prev => !prev);
  };

  return (
    <section className="section-login">
      <div className="container">
        <div className="inner-content">
          <div className="left-wrapper">
            <form onSubmit={handleSubmit}>
              <div className='content-wrapper'>
                <div className='img-box'>
                  <img src="./images/site-logo.png" alt="Site Logo" />
                </div>
                <h2>Admin Login</h2>
                {error && <p className="error-message">{error}</p>}
                <div className='form-box'>
                  <div className="form-group">
                    <input
                      type="email"
                      placeholder="Email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </div>
                  <div className="form-group password-wrapper">
                    <input
                      type={showPassword ? 'text' : 'password'}
                      placeholder="Password"
                      value={adminPassword}
                      onChange={(e) => setAdminPassword(e.target.value)}
                      required
                    />
                    <span onClick={togglePasswordVisibility}>
                      {showPassword ? '🙈' : '👁️'}
                    </span>
                  </div>
                  <button type="submit">Login</button>
                </div>
              </div>
            </form>
          </div>
          <div className="right-wrapper">
            <img src="./images/h2.jpg" alt="Login Visual" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AdminLogin;
